import { createSlice } from "@reduxjs/toolkit";
import { getAdminWalletLogsThunk } from "../thunks/walletThunk";

const initialState = {
    logs: null,
};

const walletSlice = createSlice({
    name: "wallet",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAdminWalletLogsThunk.fulfilled, (state, action) => {
            // Store the full response so the selector can read data + pagination + summary.
            state.logs = action?.payload;
        })
    }
});

export default walletSlice.reducer;
